import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import React from "react";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";

import AvgNumOfTotalAppli from '../database/AvgNumOfTotalAppli.json'
import AvgNumOfUniqueApplic from '../database/AvgNumOfUniqueApplic.json'
import Header from "./Header";

const ApplicationsDetails = () => {

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1
  };

  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{height:'80%'}}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "40px" }}>
                    <strong>&nbsp; Applications Details</strong>
                  </h2>
                </Col>
                
                <Col
                  xs={3}
                  
                  
                >
                  <Card
                    className="text-center"
                    style={{
                      
                      boxShadow: "2px 2px 8px ",
                      position:'initial',
                       height: "100px",
                       width: "210px",
                       marginTop: '3px',
                       marginLeft: "52px",
                  
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white",fontSize:'15px' }}
                    >
                      Total Unique Applications
                    </Card.Header>
                    <Card.Body style={{paddingTop:'0px', paddingottom:'0px'}}
                      
                    >
                      <strong style={{fontSize:'30px'}}>17</strong>
                    </Card.Body>
                  </Card>
                  </Col>
                  
                  <Col xs={2}>
                  <Card
                    className="text-center"
                    style={{
                      height: "100px",
                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop:'3px',
                     
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Total Applications
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      
                  <DateRangeComp/>




                    </Card.Body>
                    </Card>
                  </Col>
                
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position:'initial',
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={2}>
            <Card style={{ boxShadow: "2px 2px 8px " ,position:'initial'}}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select User
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
         

          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px " ,position:'initial'}}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={2}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                position:'initial',
                // paddingBottom: "8px",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Destination
              </Card.Header>
              <Card.Body style={{paddingTop:'5px',paddingBottom:'5px'}}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Open this select menu</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
         

          <Col xs={2}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                position:'initial',
                // paddingBottom: "8px",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Month
              </Card.Header>
              <Card.Body style={{ paddingBottom:'5px', paddingTop:'5px'}}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>Select Month</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>


          <Col xs={3}>
          <Card style={{ boxShadow: "2px 2px 8px ", width: "18rem",position:'initial' }}>
            <Card.Header style={{ color: "white", backgroundColor: "black" }}>
              Select Year
            </Card.Header>
            <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
              
              <Slider {...settings} className='slider' style={{margin:'1px'}}>
                  <div>
                    <Button variant="secondary">2017</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2019</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2020</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2021</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div>
                  
                    
                  
                </Slider>
              
            </Card.Body>
          </Card>
        </Col>


        </Row>
        <Row>
        <Col xs={3} style={{paddingTop:'8px'}}>

        <Card  style={{marginTop:'10px',textAlign:'center' ,boxShadow: "2px 2px 8px ",position:'initial'}}>
        <Card.Header style={{backgroundColor:'black',color:'white'}}>Avg Total Applications/Day.</Card.Header>
        <Card.Body>
              <Card.Subtitle><strong style={{fontSize:'50px'}}>9.76</strong></Card.Subtitle>
        </Card.Body>
        </Card>
        <Card  style={{marginTop:'18px',textAlign:'center' ,boxShadow: "2px 2px 8px "}}>
        <Card.Header style={{backgroundColor:'black',color:'white'}}>Avg Total Applications Last 60 Days</Card.Header>
        <Card.Body>
              <Card.Subtitle><strong style={{fontSize:'50px'}}>9.72</strong></Card.Subtitle>
        </Card.Body>
        </Card>
        <Card  style={{marginTop:'18px',textAlign:'center' ,boxShadow: "2px 2px 8px "}}>
        <Card.Header style={{backgroundColor:'black',color:'white'}}>Avg Unique Applications/Day</Card.Header>
        <Card.Body>
        
        <Card.Subtitle><strong style={{fontSize:'50px'}}>3.37</strong></Card.Subtitle>
        
        </Card.Body>
        </Card>
        
        
        </Col>


        <Col xs={9} style={{paddingTop:'8px'}}>
        
              <Card style={{height:'210px', marginTop:'10px' ,boxShadow: "2px 2px 8px ",position:'initial'}}>
                <Card.Title style={{textAlign:'center',textDecoration:'underline'}}>Avg Number of Total Applications/Day by Month</Card.Title>

                <Card.Body style={{paddingTop:'0px',paddingBottom:'0px'}}>
                <LeadsByMonthGraph title="No Of Total Applications." color="#e31b68"  db={AvgNumOfTotalAppli} graphType="line" height={170} />
                </Card.Body>


              </Card>

              <Card style={{height:'210px', marginTop:'10px' ,boxShadow: "2px 2px 8px "}}>
              
              <Card.Title style={{textAlign:'center',textDecoration:'underline'}}>Avg Number of Unique Applications/Day by Month</Card.Title>

              <Card.Body style={{paddingTop:'0px',paddingBottom:'0px'}}>

              <LeadsByMonthGraph color="#e31b68"  db={AvgNumOfUniqueApplic} graphType="line" height={170} />
              
              </Card.Body>



              </Card>
        
        </Col>
        </Row>
        
      </Container>
    </React.Fragment>
  );
};
export default ApplicationsDetails;